export const FORMS = {
  MAIN_LEAD_FORM: "Main Lead Form",
  DRAWER_LEAD_FORM: "Drawer Lead Form",
}
